<style>
@import '../../custom/css/lista-dicas.css';
</style>

<template>
  <div id="lista-profissoes" class="lista-dicas">
    <h1 class="title text-uppercase font-weight-bold">Lista Profissões</h1>
    <hr class="linha-amarela" />
    <table class="table">
      <thead class="letter-orange">
        <tr>
          <th>Nome</th>
          <th>Criado em.</th>
          <th>Atualizado em.</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(profissao, index) in tipoProfissoes">
          <td>{{ profissao.nome }}</td>
          <td>{{ profissao.criado_em }}</td>
          <td>{{ profissao.atualizado_em }}</td>
          <td>
            <div class="btn btn-primary" @click="editarProfissao(profissao.id)">
              <i class="fas fa-edit"></i>
            </div>
            <div class="btn btn-warning" @click="verProfissao(profissao.id)">
              <i class="fas fa-eye"></i>
            </div>
            <div class="btn btn-danger" @click="excluirProfissao(profissao.id)">
              <i class="fas fa-trash-alt"></i>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'lista-profissoes',
  computed: {
    ...mapGetters([
      'getTipoNotification',
      'getNotification',
      'getLoaderAction',
    ]),
    ...mapState({
      tipoProfissoes: (state) => state.tipoProfissoes,
    }),
  },
  created() {
    this.$store.dispatch('loadTipoProfissoes');
  },
  methods: {
    aviso(texto, tipo) {
      this.$bvToast.toast(texto, {
        title: 'Aviso',
        variant: tipo,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
    editarProfissao(id) {
      this.$router.push({
        name: 'administrador-editar-profissoes',
        params: { id },
      });
    },
    verProfissao(id) {
      this.$router.push({
        name: 'administrador-ver-profissoes',
        params: { id },
      });
    },
    async excluirProfissao(id) {
      const self = this;
      if (confirm('Deseja deletar realmente essa profissão?')) {
        self.$store.dispatch('startLoader');
        await this.$store
          .dispatch('deleteProfissao', id)
          .then((data) => {
            self.aviso('Deletado com sucesso', 'success');
            setTimeout(() => {
              self.$store.dispatch('loadTipoProfissoes').then(() => {
                setTimeout(() => {
                  self.$store.dispatch('endLoader');
                }, 1000);
              });
            }, 100);
          })
          .catch(() => {
            self.$store.dispatch('endLoader');
            self.aviso(
              'Houve um problema para deletar, tente novamente em 5 minutos!',
              'danger'
            );
          });
      }
    },
  },
};
</script>
